import NextImage from 'next/image';
import style from './Modal.module.scss';

export const Plus = ({ isOpen }) => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      onClick={isOpen}
      className={style.plus}
    >
      <circle cx='16' cy='16' r='15.744' stroke='white' strokeWidth='0.512' />
      <path d='M13.5 16.0024H19.5' stroke='white' strokeWidth='0.64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M16.5 19V13' stroke='white' strokeWidth='0.64' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const Modal = ({ visible, content, onClose, width }) => {
  if (!visible) return null;
  return (
    <div
      className={style.modal}
      onClick={onClose}
      onTouchStart={e => {
        e.stopPropagation();
      }}
      role='button'
      tabIndex='0'
    >
      <div
        className={style.modalContent}
        onTouchStart={e => {
          e.stopPropagation();
        }}
      >
        <NextImage src={content} width={width} />
      </div>
    </div>
  );
};
